import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { ReturnB2CStatus } from 'returnCenter-api';
import { getB2CStatusColor, getB2CStatusKey } from 'types/b2c';

/** Where a B2B2C return's e-commerce refund stands. Renders nothing for other returns. */
const B2CStatusBadge = ({ status }: { status?: ReturnB2CStatus | null }) => {
    const { t } = useTranslation();
    const key = getB2CStatusKey(status);
    if (!key) return null;

    return <Badge $color={getB2CStatusColor(status)}>{`B2C: ${t(key)}`}</Badge>;
};

export default B2CStatusBadge;

const Badge = styled.span<{ $color: string }>`
    border: 1px solid ${({ $color }) => $color};
    border-radius: 999px;
    color: ${({ $color }) => $color};
    font-size: 10px;
    font-weight: 600;
    padding: 0 0.4rem;
    white-space: nowrap;
`;
